export enum ServerErrors {
  CURRENT_PASSWORD_INCORRECT = 'Current password is incorrect.',
  NEW_PASSWORD_MATCH_PREVIOUS = 'New password cannot match any previously used passwords.',
}
